export enum EComparaisonLQ {

    Zero = 1,
    LQ = 2
}
